import { X } from 'lucide-react';

export default function EditModal({ 
  show, 
  editingMethod, 
  formData, 
  setFormData, 
  momoProviders, 
  onSave, 
  onCancel 
}) {
  console.log('EditModal render - show:', show, 'editingMethod:', editingMethod);
  if (!show || !editingMethod) return null;

  return (
    <div className="flex fixed inset-0 z-[9999] justify-center items-center p-4 bg-black bg-opacity-50">
      <div className="overflow-hidden mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-lg font-semibold text-gray-900">Edit Payment Method</h3>
            <button
              onClick={onCancel}
              className="text-gray-400 transition-colors hover:text-gray-600"
            >
              <X size={24} />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Provider
              </label>
              <select
                value={formData.momoType}
                onChange={(e) => {
                  const provider = momoProviders.find(p => p.id === e.target.value);
                  setFormData({ ...formData, momoType: e.target.value, providerName: provider?.name || '' });
                }}
                className="px-4 py-3 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              >
                <option value="">Select Provider</option>
                {momoProviders.map((provider) => (
                  <option key={provider.id} value={provider.id}>
                    {provider.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Phone Number
              </label>
              <input
                type="tel"
                value={formData.phoneNumber}
                onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                placeholder="+233 XX XXX XXXX"
                className="px-4 py-3 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Wallet Name
              </label>
              <input
                type="text"
                value={formData.walletName}
                onChange={(e) => setFormData({ ...formData, walletName: e.target.value })}
                placeholder="e.g., My Personal Wallet, Business Account"
                className="px-4 py-3 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              />
            </div>
          </div>

          <div className="flex gap-3 mt-8">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 rounded-lg transition-colors hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={!formData.momoType || !formData.phoneNumber || !formData.walletName}
              className={`flex-1 px-4 py-3 font-medium text-white rounded-lg transition-colors ${
                !formData.momoType || !formData.phoneNumber || !formData.walletName
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-emerald-600 hover:bg-emerald-700'
              }`}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
